var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wangEditor"},[_c('div',{ref:"toolbar",staticClass:"toolbar"}),_vm._v(" "),_c('div',{ref:"editor",staticClass:"editor-content"}),_vm._v(" "),(this.isShowClick === true)?_c('el-button',{staticClass:"button-send",attrs:{"type":"primary","plain":""},on:{"click":_vm.handleCommentSend}},[_vm._v("确定")]):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa93eb5c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WangEditor/WangEditor.vue
// module id = 1263
// module chunks = 137